const e={defaultProps:{variant:"determinate"}};export{e as default};
